import React, { SVGProps } from 'react'

export const IconFlower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9.33329"
      cy="9.33332"
      r="6.66667"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle
      cx="9.33329"
      cy="22.6666"
      r="6.66667"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle
      cx="22.6665"
      cy="9.33332"
      r="6.66667"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle
      cx="22.6665"
      cy="22.6666"
      r="6.66667"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M22.2499 9.77536L9.859 22.1662"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.85925 9.77536L22.2501 22.1662"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="16.0011"
      cy="16"
      r="4.81825"
      fill="white"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)
